angular.module('rjmNg.directives').directive "dashboardFilter", [
  () ->
    restrict: "E"
    templateUrl: "directive.dashboardFilter.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$rootScope"
      "DashboardTimeOptions"
      "$routeParams"
      "$route"
      "app"
      "Figures"
      "FEATURE_TIER"
      "Clients"
      "dashboardService"
      (
        $rootScope,
        DashboardTimeOptions,
        $routeParams,
        $route,
        app,
        Figures,
        FEATURE_TIER
        Clients
        dashboardService
      ) ->

        view = @

        view.isTimeFilterDropdownOpen = false
        view.customTimeFilterInterval = null
        view.customTimeFilterRange = null
        view.hasTimeFilterFlag = app.hasFeatureFlag('DASHBOARD_WIDE_TIME_RANGES')
        view.isStoreFilterEnabled = false

        _init = () ->
          _getCustomTimeFilterOptions($routeParams.dashId)
          _setPermissions()

        _setPermissions = () ->
          userCanEditDashboard = dashboardService.canEditDashboard()
          view.isTimeFilterDisabled = !userCanEditDashboard
          if app.isReadOnlyUser() and !userCanEditDashboard
            view.isStoreFilterEnabled = false
          else
            Clients.get($routeParams.clientId)
            .then ({properties}) ->
              {enable_store_dwf, feature_tier} = properties
              view.isStoreFilterEnabled = feature_tier is FEATURE_TIER.BASIC.toString() or enable_store_dwf is "1"

        view.deleteTimeFilter = () ->
          DashboardTimeOptions($routeParams.dashId)
          .delete()
          .then () -> 
            view.customTimeFilterRange = null
            view.customTimeFilterInterval = null
            Figures.clearCache()
            $route.reload()

        view.updateTimeFilter = (range, interval) ->
          DashboardTimeOptions($routeParams.dashId)
          .set(range, interval)
          .then ({timerange, interval}) -> 
            view.customTimeFilterRange = timerange
            view.customTimeFilterInterval = interval
            Figures.clearCache()
            $route.reload()

        _getCustomTimeFilterOptions = (dashId) ->
          DashboardTimeOptions(dashId)
          .get()
          .then ({timerange, interval}) -> 
            view.customTimeFilterRange = timerange
            view.customTimeFilterInterval = interval

        $rootScope.$on "$locationChangeSuccess", -> 
          if $route.current.params.dashId?
            _getCustomTimeFilterOptions($route.current.params.dashId)

        $rootScope.$on "openedStoreFilterDropdown", ->
          view.isTimeFilterDropdownOpen = false

        $rootScope.$on 'dashboardReady', ->
          _setPermissions()

        view.$postLink = () ->
          _init()

        view

    ]

]
